import { render, staticRenderFns } from "./runpostureShoes.vue?vue&type=template&id=fc1619e6&"
import script from "./runpostureShoes.vue?vue&type=script&lang=js&"
export * from "./runpostureShoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc1619e6')) {
      api.createRecord('fc1619e6', component.options)
    } else {
      api.reload('fc1619e6', component.options)
    }
    module.hot.accept("./runpostureShoes.vue?vue&type=template&id=fc1619e6&", function () {
      api.rerender('fc1619e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/runpostureShoes.vue"
export default component.exports